import * as Yup from 'yup';

import type { N8NConfigurationModel } from '~/server_shared/openapi/data-contracts';

export const createN8nConfigurationValidationSchema = () =>
  Yup.object().shape({
    timeout_seconds: Yup.number()
      .nullable()
      .transform((value, originalValue) => {
        if (typeof originalValue === 'string') {
          const parsed = parseInt(originalValue, 10);
          return isNaN(parsed) ? undefined : parsed;
        }
        return value;
      })
      .min(1, 'Timeout must be at least 1 second')
      .max(300, 'Timeout cannot exceed 300 seconds')
      .integer('Timeout must be a whole number')
      .required('Timeout is required'),

    is_enabled: Yup.boolean().required('Enabled status is required'),
  });

// Backward-compatible export used by tests or generic consumers.
export const N8nConfigurationValidationSchema = createN8nConfigurationValidationSchema();

export interface N8nConfigurationFormValues {
  timeout_seconds: number;
  is_enabled: boolean;
}

export const getInitialValues = (configuration?: N8NConfigurationModel): N8nConfigurationFormValues => ({
  timeout_seconds: configuration?.timeout_seconds || 30,
  is_enabled: configuration?.is_enabled ?? true,
});
